/** @format */

import store from "../store";
import Auth from "../Auth.js";

export default ({ to, from, next }) => {
  // alert(Auth.check());
  if (Auth.check() == true) {
    next("/");
  }
  next();
};
